import {FC} from 'react'
import {Link} from 'react-router-dom'
import { toAbsoluteUrl } from '../../../_metronic/helpers'

const Error404: FC = () => {
  return (
    <div className='d-flex flex-column flex-root'>
      <div className='d-flex flex-column flex-center flex-column-fluid p-10'>
        {/* begin::Illustration */}
        <h1 className='text-primary fs-hero'>404</h1>
        {/* end::Illustration */}
        {/* begin::Message */}
        <h2 className='fw-bold mb-10 fs-1' style={{color: '#A3A3C7'}}>
          Seems there is nothing here
        </h2>
        {/* end::Message */}
        {/* begin::Link */}
        <Link to='/' className='btn btn-primary'>
          Return Home
        </Link>
        {/* end::Link */}
      </div>
    </div>
  )
}

export {Error404}
